<div id="dvMainDrill">
  <div class="mainContent" style="margin-top: 50px;" *ngIf="IschartVisible[0]">
    <p class="OrgLabel">{{ChartTitle[0]}}</p><br> 
    <canvas class="AnlyticsChart" id="chart{{queindex}}" baseChart
    [data]="pieChartData"
    [labels]="pieChartLabels"    
    [options]="pieChartOptions"
    [plugins]="pieChartPlugins"        
    [legend]="pieChartLegend">></canvas>
</div>
  <div *ngIf="seqNum.length>0">
  
  <div class="dependentChart" *ngFor="let item of seqNum" >
    <ng-container [ngTemplateOutlet]="barChartData[item-2].length===0? NoDataFound :drillDownChartData[chartIndex].sequentialChartType[item-1].chartType=='SplitBar'?HorizonatalSplitBar: HorizonatalStackedBar"     
    [ngTemplateOutletContext]="{sequenceNum:item}">
    </ng-container>
  </div>
  </div>

    <ng-template class="mt-3" #HorizonatalStackedBar let-sequenceNum='sequenceNum'>   
          <div class="mainContent" style="margin-top: 60px;" *ngIf="IschartVisible[sequenceNum-1]===true">
            <p class="OrgLabel">{{ChartTitle[sequenceNum-1]}}</p><br>    
          <canvas class="AnlyticsChart " style="height: 450px !important;" id="chartName-{{sequenceNum}}"     baseChart
            [datasets]="barChartData[sequenceNum-2]"
            [labels]="barChartLabel[sequenceNum-2]"
            [options]="barChartOptions"          
            [legend]="barChartLegend"             
            [plugins]="barChartPlugins" 
            ></canvas>
      </div>
    </ng-template>

  <div style="margin-top:100px ;">
    <ng-template  class="mt-3" #HorizonatalSplitBar let-sequenceNum='sequenceNum'>       
    
              
           
      <div class="mainContent" style="margin-top: 60px;">
        <p class="OrgLabel">{{ChartTitle[sequenceNum-1]}}</p><br> 
        <canvas class="AnlyticsChart" id="chartName-{{sequenceNum}}"   baseChart
          [datasets]="barChartData[sequenceNum-2]"
          [labels]="barChartLabel[sequenceNum-2]"
          [options]="splitBarChartOptions"          
          [legend]="barChartLegend"           
          [plugins]="barChartPlugins" 
          ></canvas>
  </div>  
  </ng-template>

    <ng-template  class="mt-3" #NoDataFound let-sequenceNum='sequenceNum'>         
      <div class="mainContent" style="margin-top: 60px;">
        <div class="dvTitle"> 
        <p class="OrgLabel">{{ChartTitle[sequenceNum-1]}}</p><br>       
      </div> 
      <div>
        <p>No Data Found</p>
      </div>  
    </div>
  </ng-template>
</div>
</div>